import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

let globalAuthError = null;

export const useAuth = () => {
  return useContext(AuthContext);
};

export const getGlobalAuthError = () => globalAuthError;

export const triggerAuthError = (message) => {
  globalAuthError = message;
  const event = new CustomEvent("auth-error", { detail: message });
  window.dispatchEvent(event);
};

export const triggerAuthRedirect = (path) => {
  const event = new CustomEvent("auth-redirect", { detail: path });
  window.dispatchEvent(event);
};

export const AuthProvider = ({ children }) => {
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const handleAuthError = (event) => {
      setAuthError(event.detail);
    };

    window.addEventListener("auth-error", handleAuthError);

    return () => {
      window.removeEventListener("auth-error", handleAuthError);
    };
  }, []);

  const clearAuthError = () => {
    globalAuthError = null;
    setAuthError(null);
  };

  const value = {
    authError,
    clearAuthError,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
